module.exports = __webpack_public_path__ + "media/images/soar/operation_screen-ed11186b21bea6f9438c8f3ecbd5b743.png";